export enum IConfigKey {
  commonAutowrap = 'common.autowrap', // 是否折行
  commonOpenmethod = 'common.openmethod', // 打开方式
  commonMenuExpandType = 'common.menuExpandType', // 菜单展开收起方式
  commonBatchFirstPageSelected = 'common.batchFirstPageSelected', // 批量操作首页默认选中
  commonSearchHidePanel = 'common.searchHidePanel', // 批量操作首页默认选中
}

export interface Task {
  func: Function;
  resolve: Function;
  reject: Function;
}

export interface IConfigKeyData {
  configKey: string;
  configValue: string;
}

export const configData = [
  {
    configKey: IConfigKey.commonAutowrap,
  },
  {
    configKey: IConfigKey.commonMenuExpandType,
  },
  {
    configKey: IConfigKey.commonOpenmethod,
  },
  {
    configKey: IConfigKey.commonBatchFirstPageSelected,
  },
  {
    configKey: IConfigKey.commonSearchHidePanel,
  },
];

export const generateConfigValue = (data: any) => {
  if (!Array.isArray(data)) return;
  let config: any = {};
  data.forEach((item: IConfigKeyData) => {
    config[item.configKey] = item.configValue;
  });
  return config;
};
